module.exports = __webpack_public_path__ + "static/img/smartstation44.88a137fd.png";